import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';

function HoldingHistoryColumn() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Column style={{marginRight: '168px', marginLeft: '28px'}}>{t('memberDetail.colPeriod')}</Column>
      <Column style={{marginRight: '92px'}}>{t('memberDetail.colAppliedDays')}</Column>
      <Column style={{marginRight: '285px'}}>{t('memberDetail.colMembership')}</Column>
      <Column>{t('memberDetail.colStatus')}</Column>
    </TopLevelWrapper>
  )
}

export default HoldingHistoryColumn;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: center;
  
  // justify-content: center;
  align-items: center;

  width: 1020px;
  margin-top: 34px;
  margin-bottom: 20px;
  
  transition: all 0.3s ease-in-out;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;
